'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createModule = undefined;

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

exports.updateListHash = updateListHash;
exports.connect = connect;

var _apply = require('./apply');

var _apply2 = _interopRequireDefault(_apply);

var _getRoot = require('./get-root');

var _getRoot2 = _interopRequireDefault(_getRoot);

var _list2 = require('../list/_list');

var _list3 = _interopRequireDefault(_list2);

var _options = require('../list/options');

var _options2 = _interopRequireDefault(_options);

var _expireAll = require('../list/expire-all');

var _expireAll2 = _interopRequireDefault(_expireAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = '_rest-store';
var HOOKED = (0, _symbol2.default)('rest-store hooked');

var createModule = exports.createModule = function createModule(store) {
    return {
        namespaced: true,

        state: { hooked: HOOKED },

        mutations: {
            updateListHash: function updateListHash(state, opts) {
                var namespace = opts.namespace,
                    listName = opts.listName,
                    hash = opts.hash;

                var root = (0, _getRoot2.default)(store.state, namespace);
                var list = (0, _list3.default)(root, listName);

                if (list.hash === hash) return;

                (0, _apply2.default)(_options2.default, root, listName, { hash: hash });
                (0, _apply2.default)(_expireAll2.default, root, listName);
            }
        }
    };
};

function updateListHash(store, namespace, listName, hash) {
    var commit = store.commit,
        state = store.state;

    var root = (0, _getRoot2.default)(state, namespace);
    var list = (0, _list3.default)(root, listName);

    if (list.hash === hash) return;

    connect(store);
    commit('_rest-store/updateListHash', { listName: listName, namespace: namespace, hash: hash });
}

function connect(store) {
    var module = store.state[NAME];

    if (module && module.hooked == HOOKED) return;

    var m = createModule(store);
    store.registerModule(NAME, m);
}

exports.default = module;